export const imageSizesArray = [100, 240, 300, 400, 500, 600, 750, 800, 950, 1400, 1600] as const;
export type ImageSizesType = (typeof imageSizesArray)[number];
